module.exports = __webpack_public_path__ + "img/pm10T.6dcb1c67.png";